export const locale = {
  lang: "ar",
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "لوحات القيادة",
      },
      ESP: {
        COLLAPSIBLE: "Espace marchand",
      },
      Wallet: {
        SECTION: "محفظة",
        AW: {
          COLLAPSIBLE: "تمويل محفظتي",
          Carte: "عن طريق بطاقة الدفع",
          Espece: "عن طريق الدفع / التحويل",
          RV: "من خلال نقطة بيع",
        },
        TA: {
          COLLAPSIBLE: "تحويل مبلغ",
          ws: "محفظة SPW",
          cb: "حساب بنكي",
        },
        MW: {
          COLLAPSIBLE: "Mes wallets",
        },
      },
      SERVICE: {
        SECTION: "خدمات",
        RT: {
          COLLAPSIBLE: "إعادة تعبئة الهاتف",
          TD: "تحويل مباشر",
          CR: "شحن الهاتف",
        },
        DS: {
          COLLAPSIBLE: "ترفيه",
        },
        PM: {
          COLLAPSIBLE: "الدفع للبائع",
        },
        GCB: {
          COLLAPSIBLE: "إدارة البطاقات",
        },
      },
      AUTRE: {
        SECTION: "****",
        FP: {
          COLLAPSIBLE: "برنامج الوفاء",
        },
        MT: {
          COLLAPSIBLE: "المعاملات",
        },
        MC: {
          COLLAPSIBLE: "استهلاك",
        },
        dashm: {
          COLLAPSIBLE: "لوحة تحكم التاجر",
        },
        moncompte: {
          COLLAPSIBLE: "حسابي",
        },
        trvr: {
          COLLAPSIBLE: "تحويل مبلغ",
        },
        his: {
          COLLAPSIBLE: "سجل المعاملات",
        },
        conso: {
          COLLAPSIBLE: "الاستهلاك",
        }


      },
      DOC: {
        SECTION: "Documents",
      },
      FAQ: {
        SECTION: "للاسئلة والإتصال",
      },
    },
  },
};
